module.exports = __webpack_public_path__ + "static/img/lysyy.afaff81.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/lysyy.png
// module id = Gixt
// module chunks = 0